import { createSlice } from '@reduxjs/toolkit';

export const languageSlice = createSlice({
  name: 'language',
  initialState: {
    language: 'so',
  },
  reducers: {
    setLanguage: (state, action) => {
      state.language = action.payload
    },
  },
});

export const { setLanguage } = languageSlice.actions; // Exporting setLanguage action creator

export default languageSlice.reducer;
